export const SAN_FRANCISCO_COORDINATES = {
  lat: 37.81550523889406,
  lng: -122.38713192156683,
};

// const searchMapMarkers = boatLocations?.map((item) => {
//   return (
//     <SearchMapMarker
//       key={item?.boat_public_id}
//       location={item?.location}
//       price={item?.price_per_hour_cents}
//     />
//   );
// });
